import { getValuationDates } from '../../../HttpRequests/valuationDates'
import { loadValuationDates } from '../State/project'
import { setFetching } from '../State/fetching'
import { getProps } from '../props'
import handleException from '../../../Core/Helpers/handleException'

export default () => async (dispatch) => {

  const { id } = getProps().match.params

  const params = {
    'filter[project_id]': id,
  }

  dispatch(setFetching(true))

  try {

    const response = await getValuationDates({ id, params })

    dispatch(loadValuationDates(response.data))

  } catch (error) {

    handleException(error)

  } finally {

    dispatch(setFetching(false))

  }

}
